import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Check, Trophy, Star, BookOpen } from 'lucide-react';
const options = [{
  id: 'standard',
  icon: '📘',
  title: 'SUPER COMBO CARPINTERÍA PLEGABLE PRO',
  subtitle: '6 Tomos + 6 Bonos',
  idealFor: 'Ideal para: Todos los niveles de carpintería',
  oldPrice: '$34.990',
  price: '$19.990 ARS',
  url: 'https://solucionstore.shop/cart/45476813504703:1'
}, {
  id: 'premium',
  icon: '🏆',
  title: 'SUPER COMBO + SISTEMA MICRO-FÁBRICA',
  badge: '⭐ LA MÁS ELEGIDA',
  subtitle: '6 Tomos + 6 Bonos + Sistema Micro-Fábrica™',
  idealFor: 'Ideal para: Carpinteros que quieren escalar, producir por lotes y vivir de esto',
  oldPrice: '$43.990',
  price: '$27.990 ARS',
  url: 'https://solucionstore.shop/cart/45476839882943:1'
}];
export function Pricing() {
  const [selected, setSelected] = useState('standard');
  const selectedOption = options.find(o => o.id === selected)!;
  return <section id="comprar" className="py-24 bg-charcoal relative" data-id="element-266">
      <div className="container mx-auto px-4" data-id="element-267">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-14" data-id="element-268">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-2" data-id="element-269">
            ELEGÍ TU <span className="text-amber" data-id="element-270">SUPER COMBO</span>
          </h2>
          <p className="text-lg text-white/60 italic mt-4" data-id="element-271">
            Las dos opciones incluyen los 6 bonos estratégicos completos
          </p>
        </motion.div>

        <div className="max-w-2xl mx-auto space-y-5 mb-10" data-id="element-272">
          {options.map(option => {
          const isSelected = selected === option.id;
          return <motion.button key={option.id} type="button" initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} onClick={() => setSelected(option.id)} className={`w-full text-left rounded-2xl p-6 md:p-8 border-2 transition-all duration-300 cursor-pointer relative ${isSelected ? 'border-amber bg-wood-dark/80 shadow-[0_0_25px_rgba(245,197,66,0.15)]' : 'border-white/10 bg-wood-dark/40 hover:border-white/30'}`} data-id="element-273">
                {option.badge && <span className="absolute -top-3 right-6 bg-amber text-wood-dark text-xs font-black px-4 py-1 rounded-full tracking-wider" data-id="element-274">
                    {option.badge}
                  </span>}

                <div className="flex items-start gap-4" data-id="element-275">
                  {/* Radio */}
                  <div className="mt-1 flex-shrink-0" data-id="element-276">
                    <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${isSelected ? 'border-amber' : 'border-white/30'}`} data-id="element-277">
                      {isSelected && <motion.div initial={{
                    scale: 0
                  }} animate={{
                    scale: 1
                  }} className="w-3 h-3 rounded-full bg-amber" data-id="element-278" />}
                    </div>
                  </div>

                  {/* Content */}
                  <div className="flex-grow min-w-0" data-id="element-279">
                    <div className="flex items-center gap-2 mb-1" data-id="element-280">
                      <span className="text-2xl" data-id="element-281">{option.icon}</span>
                      <h3 className="text-lg md:text-xl font-black text-white leading-tight" data-id="element-282">
                        {option.title}
                      </h3>
                    </div>
                    <p className="text-white/60 text-sm mb-1" data-id="element-283">
                      {option.subtitle}
                    </p>
                    <p className="text-amber text-sm font-semibold italic" data-id="element-284">
                      {option.idealFor}
                    </p>
                  </div>

                  {/* Price */}
                  <div className="flex-shrink-0 text-right" data-id="element-285">
                    <span className="text-white/40 line-through text-sm block" data-id="element-286">
                      {option.oldPrice}
                    </span>
                    <span className="text-2xl md:text-3xl font-black text-white" data-id="element-287">
                      {option.price}
                    </span>
                  </div>
                </div>
              </motion.button>;
        })}
        </div>

        {/* Single CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto" data-id="element-288">
          <a href={selectedOption.url} target="_blank" rel="noopener noreferrer" className="block w-full bg-amber hover:bg-amber-dark text-wood-dark font-black text-xl md:text-2xl text-center py-5 md:py-6 rounded-2xl transition-all duration-300 hover:-translate-y-1 shadow-[0_8px_30px_rgba(245,197,66,0.3)] hover:shadow-[0_12px_40px_rgba(245,197,66,0.4)]" data-id="element-289">
            → QUIERO MI SUPER COMBO AHORA
          </a>
        </motion.div>

        {/* Trust badges */}
        <div className="flex flex-wrap justify-center items-center gap-6 mt-10 text-sm text-white/60 font-medium" data-id="element-290">
          <span className="flex items-center" data-id="element-291">
            <ShieldCheck className="w-5 h-5 mr-2 text-amber" data-id="element-292" /> Pago seguro
          </span>
          <span className="flex items-center" data-id="element-293">
            <Check className="w-5 h-5 mr-2 text-amber" data-id="element-294" /> Acceso en 5 min
          </span>
          <span className="flex items-center" data-id="element-295">
            <ShieldCheck className="w-5 h-5 mr-2 text-amber" data-id="element-296" /> Garantía 7 días
          </span>
          <span className="flex items-center" data-id="element-297">
            <Check className="w-5 h-5 mr-2 text-amber" data-id="element-298" /> Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}